"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Actions = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _state = require("../../../../state");
var _ui = require("../../../ui");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var google = function google(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.625 12.0016C5.625 10.8126 5.95261 9.69867 6.52177 8.74491V4.69922H2.47608C0.870375 6.78459 0 9.32611 0 12.0016C0 14.6772 0.870375 17.2187 2.47608 19.3041H6.52177V15.2584C5.95261 14.3046 5.625 13.1907 5.625 12.0016Z",
    fill: "#FBBD00"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 18.3768L9.1875 21.1893L12 24.0018C14.6756 24.0018 17.217 23.1315 19.3024 21.5257V17.4844H15.261C14.2989 18.0556 13.1804 18.3768 12 18.3768Z",
    fill: "#31AA52"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.52225 15.2578L2.47656 19.3035C2.79447 19.7164 3.14064 20.1118 3.51522 20.4864C5.78172 22.7528 8.79517 24.0011 12.0005 24.0011V18.3761C9.67436 18.3761 7.63563 17.1236 6.52225 15.2578Z",
    fill: "#31AA52"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 12.0004C24 11.2704 23.9339 10.5389 23.8035 9.82652L23.698 9.25H12V14.875H17.6931C17.1402 15.9747 16.2902 16.872 15.261 17.483L19.3024 21.5244C19.7153 21.2065 20.1106 20.8603 20.4853 20.4857C22.7518 18.2192 24 15.2057 24 12.0004Z",
    fill: "#3C79E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.5078 7.49217L17.005 7.98933L20.9825 4.01189L20.4853 3.51473C18.2188 1.24823 15.2054 0 12 0L9.1875 2.8125L12 5.625C13.7028 5.625 15.3037 6.28809 16.5078 7.49217Z",
    fill: "#EB4132"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.0005 5.625V0C8.79522 0 5.78177 1.24823 3.51522 3.51469C3.14064 3.88927 2.79447 4.28466 2.47656 4.69758L6.52225 8.74326C7.63567 6.8775 9.67441 5.625 12.0005 5.625Z",
    fill: "#EB4132"
  }));
};
google.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ShadowButton = (0, _styledComponents.default)(_ui.ShadowButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n"])));
var Actions = function Actions(_ref) {
  var type = _ref.type;
  var _useTranslation = (0, _reactI18next.useTranslation)('libAuth'),
    t = _useTranslation.t;
  var _useOAuth = (0, _state.useOAuth)(),
    _useOAuth$google = _useOAuth.google,
    authorizeLoading = _useOAuth$google.authorizeLoading,
    authorize = _useOAuth$google.authorize;
  return /*#__PURE__*/_react.default.createElement(ShadowButton, {
    type: "button",
    iconPosition: "left",
    icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: google
    }),
    onClick: authorize,
    loading: authorizeLoading,
    wide: true,
    id: "".concat(type.toLowerCase(), "-google")
  }, t(type + 'Google'));
};
exports.Actions = Actions;